export const subscriptionPlansApi = {
 fetchPlanList: (): string => `/api/admin/subscription-plans`,
 createPlan: (): string => `/api/admin/subscription-plans`,
 fetchPlan: (id: string): string => `/api/admin/subscription-plans/${id}`,
 updatePlan: (id: string): string => `/api/admin/subscription-plans/${id}`,
 deletePlan: (id: string): string => `/api/admin/subscription-plans/${id}`,
 deactivatePlan: (id: string): string =>
  `/api/admin/subscription-plans/${id}/deactivate`,
 activatePlan: (id: string): string =>
  `/api/admin/subscription-plans/${id}/activate`,
};
